export const ROUTES: Record<string, string> = {
  HOME: "/",
  AUTH_LOGIN: "/login",
  AUTH_RECOVERY: "/recovery",
  AUTH_NEW_PASS: "/accounts/password/reset/confirm/:uid/:token",
  AUTH_ACTIVATION: "/accounts/activation/:uid/:token",
  AUTH_VERIFY: "/verify",
  AUTH_SIGNUP: "/signup/:account_type?",
  AUTH_SIGNUP_DEFAULT: "/signup",
  AUTH_ADD_NUMBER: "/signup/add_number",
  AUTH_CONFIRM_NUMBER: "/signup/confirm_number",
  AUTH_CONFIRM: "/confirm_email",
  AUTH_PHONE_CONFIRMED: "/phone_confirmed",
  BUY: "/buy",
  //CASH_OUT: "/cashout",
  CHANGE_EMAIL: "/change-email/:token",
  CONTACTS: "/contacts",
  CONTACT_LINK_CONFIRMATION: "/contact-link/:id/",
  DEPOSIT: "/deposit",
  INVOICE: "/invoice/:id",
  INVOICE_BUSSINES_VIEW: "/invoice/:id/view",
  KYC: "/kyc",
  ONMETA_KYC_FAILURE: "/onmeta-kyc-failure",
  ONMETA_KYC_SUCCESS: "/onmeta-kyc-success",
  PAY: "/pay",
  PAYMENT_REQUESTS: "/payment-requests",
  PAYMENT_REQUEST: "/payment-requests/:id",
  //PAYMENT_REQUEST_HOME: "/payment-requests/home",
  PAYMENT_REQUEST_PUBLIC: "/payment-requests/:id/public",
  PARTNER_PAYMENT_REQUEST_PUBLIC: "/p/payment-link/:id/public",
  PROFILE_GENERAL: "/settings",
  PROFILE_INVOICE: "/settings/invoice_details",
  PROFILE_CONTACTS: "/settings/contacts",
  PROFILE_SECURITY: "/settings/security",
  PUBLIC_CALCULATOR: "/transfer-calculator",
  RECEIVE: "/receive",
  USD_ACCOUNT: "/usd",
  WALLETS: "/wallets",
  ACCOUNT_DELETED: "/account_deleted",
  MAINTENANCE: "/405",
  LINK_EXPIRED: "/link_expired",
  AUTH_LINK_EXPIRED: "/auth_link_expired",
  VERIFIED: "/verified",
  VERIFICATION_FAIL: "/verification_fail",
  VERIFICATION_SUSPECTED: "/verification_suspected",
  NOT_FOUND: "/404",
};

export const HOME_ROUTE = ROUTES.HOME;
